import type { CouponType } from "@/components/promotion-panel";
import PromotionPanel from "@/components/promotion-panel";
import { cn } from "@/lib/utils";

interface PromotionsProps {
  className?: string;
  coupons: CouponType[];
  name: string;
}

export default function Promotions({
  className,
  coupons,
  name,
}: PromotionsProps) {
  if (!coupons.length) {
    return null;
  }

  return (
    <div className={cn("mb-8", "Game_Promotions", className)}>
      <h5 className="font-semibold text-24">Promotions</h5>
      {name && <p className="mt-2 mb-6 text-18">Current deals for {name}</p>}
      <div className="scrollbar-hidden relative -mx-6 flex snap-x snap-mandatory scroll-pl-6 justify-between gap-2.5 overflow-auto *:snap-start md:mx-0 md:block md:space-y-3.5 md:overflow-visible">
        {coupons.map((coupon) => (
          <PromotionPanel coupon={coupon} key={coupon.id} />
        ))}
      </div>
    </div>
  );
}
